import React from 'react';
import { useStore } from '../context/store';
import Taxonomy from './Taxonomy';

export default function Taxonomies() {
	const { state, dispatch } = useStore();

	if (Object.keys(state.taxonomies).length !== 0) {
		return (
			<div className="tf-taxonomies">
				{state.taxonomies.map((taxonomy) => {
					return <Taxonomy taxonomy={taxonomy} key={taxonomy.name} />;
				})}
			</div>
		);
	}
	return '';
}
